/*
 * pv-filter-open-sync.js
 * ----------------------
 * Fixes the "open filter panel overlays the first product row" issue that appears
 * when the desktop filters are OPEN BY DEFAULT (our open-on-load change).
 *
 * WHY IT'S NEEDED: the theme's <filter-details> panel is position:absolute, so it
 * doesn't take layout space on its own — the theme reserves space with a spacer
 * div ([data-placeholder]) that it sizes inside a `toggle` EVENT handler. But a
 * <details> that is already `open` in the HTML does NOT fire `toggle` on load, so
 * the spacer stays at 0 and the panel lays over the grid. (On click it works,
 * because clicking fires `toggle`.)
 *
 * WHAT THIS DOES: sizes that spacer ourselves on load, using the SAME formula the
 * theme uses (spacer height = panel offsetHeight), and re-sizes it as the panel's
 * height settles. The filter controls are cloned into the panel asynchronously by
 * `filters-submit`, so the panel grows shortly after load — a single measurement is
 * always slightly short (the small overlap you see). A ResizeObserver keeps it
 * correct. It also re-syncs on real toggles, so it composes cleanly with the
 * theme's own click-open/close behavior (both set the same value; idempotent).
 *
 * Loaded once via collection-filters-top.liquid (a proper asset_url include, so it
 * is cache-busted normally — unlike the webpack chunk). No-op when no panel is open.
 */
(function () {
  if (window.__pvFilterOpenSync) return;   // load-once guard
  window.__pvFilterOpenSync = true;

  // The theme moves the spacer to be a sibling right after .collection-filters-top,
  // so it's no longer a descendant of <filter-details>. Find it accordingly, with a
  // document-wide fallback (there is one filter bar per collection page).
  function placeholderFor(fd) {
    var top = fd.closest('.collection-filters-top');
    if (top) {
      var sib = top.nextElementSibling;
      if (sib && sib.matches && sib.matches('[data-placeholder]')) return sib;
    }
    return document.querySelector('[data-placeholder]');
  }

  function wire(fd) {
    var details = fd.querySelector('details');
    var content = fd.querySelector('[data-filter-details-content]');
    var ph = placeholderFor(fd);
    if (!details || !content || !ph) return;

    var size = function () {
      ph.style.height = details.open ? (content.offsetHeight + 'px') : '0px';
    };

    size();                                    // initial sizing on load
    details.addEventListener('toggle', size);  // stay correct on click open/close
    if (window.ResizeObserver) {
      new ResizeObserver(size).observe(content); // re-sync as the panel settles
    }
  }

  function init() {
    var panels = document.querySelectorAll('filter-details');
    for (var i = 0; i < panels.length; i++) wire(panels[i]);
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();